// extracted by mini-css-extract-plugin
export var blackBackground = "logoCta-module--black-background--0da82";
export var button = "logoCta-module--button--1a67c";
export var copy = "logoCta-module--copy--756d8";
export var headline = "logoCta-module--headline--8d8e7";
export var logo = "logoCta-module--logo--c512c";
export var logoCta = "logoCta-module--logo-cta--68a8c";